import React from 'react'

export default function Folder(pages, pageId, addCallback, getCallback, openPagesMap, setOpenPagesMap, isMoving, movePage) {

  const onClickText = () => {
    console.log("On click: " + pageId + " isOpen: " + (!openPagesMap[pageId]))

    setOpenPagesMap(oldState => {
      let newState = { ...oldState }
      newState[pageId] = !openPagesMap[pageId]
      return newState
    });
    if (!isMoving) {
      getCallback(pageId)
    }
  }

  const onClickButton = () => {
    if (isMoving) {
      movePage(pageId)
    } else {
      addCallback(pageId)
    }
  }

  return (
    <div className='folder' key={pageId}>
      <span onClick={onClickText}>{pages[pageId].name === undefined || pages[pageId].name.length === 0 ? "<Untitled>" : pages[pageId].name}</span>
      <button onClick={onClickButton}>{isMoving ? "Move Here" : "Add"}</button>
      <br />
      {openPagesMap[pageId] ?
        pages[pageId].pages.map((subpage) => {
          return Folder(pages, subpage, addCallback, getCallback, openPagesMap, setOpenPagesMap, isMoving, movePage)
        })
        : null}
    </div>
  )
}